export default __webpack_public_path__ + "static/media/1897.b5995483.png";